/*!
VueLayers
Web map Vue components with the power of OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.10.25
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _Object$defineProperties = _interopDefault(require('babel-runtime/core-js/object/define-properties'));
var mergeDescriptors = _interopDefault(require('../util/multi-merge-descriptors'));
var useMapCmp = _interopDefault(require('./use-map-cmp'));
var cmp = _interopDefault(require('./ol-virt-cmp'));

var methods = {
  /**
   * @return {OlStyle|Promise<OlStyle>}
   * @protected
   */
  createOlObject: function createOlObject() {
    return this.createStyle();
  },

  /**
   * @return {OlStyle|Promise<OlStyle>}
   * @protected
   * @abstract
   */
  createStyle: function createStyle() {
    throw new Error('Not implemented method');
  },

  /**
   * @return {Promise}
   * @protected
   */
  init: function init() {
    return cmp.methods.init.call(this);
  },

  /**
   * @return {void|Promise<void>}
   * @protected
   */
  deinit: function deinit() {
    return cmp.methods.deinit.call(this);
  },

  /**
   * @return {Object}
   * @protected
   */
  getServices: function getServices() {
    var vm = this;

    return mergeDescriptors(cmp.methods.getServices.call(this), {
      get style() {
        return vm.$style;
      }
    });
  },

  /**
   * @return {Promise}
   */
  refresh: function refresh() {
    return this.remount();
  }
};

var style = {
  mixins: [cmp, useMapCmp],
  methods: methods,
  stubVNode: {
    empty: function empty() {
      return this.$options.name;
    }
  },
  created: function created() {
    var _this = this;

    _Object$defineProperties(this, {
      $style: {
        enumerable: true,
        get: function get() {
          return _this.$olObject;
        }
      },
      $map: {
        enumerable: true,
        get: function get() {
          return _this.$services && _this.$services.map;
        }
      },
      $view: {
        enumerable: true,
        get: function get() {
          return _this.$services && _this.$services.view;
        }
      },
      $stylesContainer: {
        enumerable: true,
        get: function get() {
          return _this.$services && _this.$services.stylesContainer;
        }
      }
    });
  }
};

module.exports = style;



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/mixin/style.js
// module id = 85
// module chunks = 1